import { Route } from "@angular/router";
import { authGuard, rolesGuard } from "@core/guards";
import { AnnualStatementPageFilter } from "@models/annual-statements/annual-statement-enums";
import {
  AnnualStatementPageComponent
} from "@pages/annual-statements/components/annual-statement-page/annual-statement-page.component";
import {
  AnnualStatementsPageComponent
} from "@pages/annual-statements/components/annual-statements-page/annual-statements-page.component";
import {
  ImportedDocumentPageComponent
} from "../../generate-documents/components/imported-document-page/imported-document-page.component";

export function getAnnualStatementsRoutes(): Route[] {
  return [
    {
      path: 'annual-statements',
      title: 'Annual Statements',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      children: [
        {
          path: '',
          redirectTo: 'ready-to-send',
          pathMatch: 'full',
        },
        {
          title: 'Ready to Send',
          path: 'ready-to-send',
          component: AnnualStatementsPageComponent,
          data: { key: AnnualStatementPageFilter.ReadyToSend }
        },
        {
          title: 'Not Received',
          path: 'not-received',
          component: AnnualStatementsPageComponent,
          data: { key: AnnualStatementPageFilter.NotReceived }
        },
        {
          title: 'Expected',
          path: 'expected',
          component: AnnualStatementsPageComponent,
          data: { key: AnnualStatementPageFilter.Expected }
        },
        {
          title: 'Sent',
          path: 'sent',
          component: AnnualStatementsPageComponent,
          data: { key: AnnualStatementPageFilter.Sent }
        },
        {
          title: 'Payment Due',
          path: 'payment-due',
          component: AnnualStatementsPageComponent,
          data: { key: AnnualStatementPageFilter.PaymentDue }
        },
        {
          title: 'Overdue',
          path: 'overdue',
          component: AnnualStatementsPageComponent,
          data: { key: AnnualStatementPageFilter.Overdue }
        },
        {
          title: 'Archived',
          path: 'archived',
          component: AnnualStatementsPageComponent,
          data: { key: AnnualStatementPageFilter.Archived }
        },
        {
          title: 'All',
          path: 'all',
          component: AnnualStatementsPageComponent,
          data: { key: AnnualStatementPageFilter.All }
        },
        {
          path: ':id',
          component: AnnualStatementPageComponent,
          title: 'Annual Statements',
          canActivate: [
            () => rolesGuard(['Admin', 'Manager', 'Preparer'], '/annual-statement/ready-to-send')
          ]
        },
      ],
    },
    {
      path: 'imported-annual-statement/:id',
      component: ImportedDocumentPageComponent,
      title: ImportedDocumentPageComponent.importedAnnualStatementTitle,
      canActivate: [
        authGuard,
        () => rolesGuard(['Admin', 'Manager', 'Preparer'], '/documents')
      ]
    },

  ];
}
